import {DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {useEffect, useRef} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {CatalogueType} from '../../../../../hooks/useCatalogue';
import {useGetPriceReportCarDetailQuery} from '../../../../../store/priceReportApi';
import {PriceReportType} from '../../../../../types/PriceReportType';
import {VehicleCard} from '../../../../AdvertisementPage/components/VehicleCard';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

interface SelectedVehicleCardProps {
  priceReport: PriceReportType;
  vehicleId: string | Nullish;
  vehicle?: ExtendedStatisticsCar;
  catalogue: CatalogueType;
  shouldScrollIntoView?: boolean;
}

export function SelectedVehicleCard(props: SelectedVehicleCardProps) {
  const vehicleCardRef = useRef<HTMLDivElement>(null);
  const {data, isFetching, isError} = useGetPriceReportCarDetailQuery(
    {reportId: props.priceReport.id, vehicleId: props.vehicleId ?? ''},
    {skip: isNilOrEmpty(props.vehicleId)}
  );

  useEffect(() => {
    if (data && props.shouldScrollIntoView) {
      vehicleCardRef.current?.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    }
  }, [data, props.shouldScrollIntoView]);

  if (isNilOrEmpty(props.vehicleId)) {
    return null;
  }

  return (
    <DataStatus isLoading={isFetching} isError={isError} minHeight={46}>
      {data && (
        <Box minHeight={46} ref={vehicleCardRef}>
          <VehicleCard
            catalogue={props.catalogue}
            priceReport={props.priceReport}
            // TODO T20-98639 Remove workaround for `is_sold` and `props.vehicle` once the backend is fixed
            vehicle={{...data, is_sold: props.vehicle?.is_sold ?? data.is_sold, isMyVehicle: false}}
            isMyVehicle={false}
          />
        </Box>
      )}
    </DataStatus>
  );
}
